let initialState = []

const GetSubTopicByTopicReducer = (state=initialState,action) => {
    switch(action.type)
    {
        case 'GET_SUBTOPIC_BYTOPIC':
            {
                state=action.payload;
                //if(state.length<=1) return new Array();
                return [...state];
            }

        default:
             return state;
    }
}

export default GetSubTopicByTopicReducer;